const HeroSection = () => {
  const scrollToCategories = () => {
    const categoriesSection = document.getElementById('categories');
    if (categoriesSection) {
      categoriesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-50 via-orange-50/30 to-amber-50/40">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f850782b16b19c81e894bd8abc178b4a.jpg"
          alt="Abstract geometric background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-32 lg:py-40">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Content Zone */}
          <div className="lg:col-span-6 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="w-1.5 h-1.5 bg-orange-500 rounded-full"></span>
              <span className="text-xs font-semibold tracking-wider uppercase text-orange-600 whitespace-nowrap">
                Trusted Recommendations
              </span>
            </div>

            <h2 className="text-5xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight font-inter">
              Expert Insights
              <br />
              Across <strong className="text-orange-600">23 Niches</strong>
            </h2>

            <p className="text-lg lg:text-xl text-gray-700 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Research-backed guides, honest reviews, and curated recommendations to help you make informed decisions
            </p>

            <button
              onClick={scrollToCategories}
              className="inline-flex items-center gap-4 bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap group"
            >
              <span className="text-base font-medium">Explore Categories</span>
              <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full group-hover:bg-orange-600 transition-colors">
                <i className="ri-arrow-down-line text-lg"></i>
              </div>
            </button>
          </div>

          {/* Right Visual Zone */}
          <div className="lg:col-span-6 relative">
            <div className="relative w-full h-96 lg:h-[500px]">
              {/* Decorative Cards */}
              <div className="absolute top-0 right-0 w-64 h-48 bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 transform rotate-3 hover:rotate-0 transition-transform duration-300">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-lg">
                    <i className="ri-star-line text-orange-600 text-xl"></i>
                  </div>
                  <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">Top Rated</span>
                </div>
                <p className="text-xs text-gray-600 leading-relaxed">
                  Discover our most trusted recommendations across all categories
                </p>
              </div>

              <div className="absolute bottom-12 left-0 w-64 h-48 bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 transform -rotate-3 hover:rotate-0 transition-transform duration-300">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-shield-check-line text-teal-600 text-xl"></i>
                  </div>
                  <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">Verified Reviews</span>
                </div>
                <p className="text-xs text-gray-600 leading-relaxed">
                  Every recommendation backed by thorough research and testing
                </p>
              </div>

              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 h-56 bg-gradient-to-br from-orange-400/20 to-teal-400/20 rounded-full blur-3xl"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-gray-900/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-gray-900/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
